module.exports = __webpack_public_path__ + "static/img/no-data.4fa8d8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/no-data.png
// module id = canR
// module chunks = 1